import { ReactNode } from 'react';
import styled from 'styled-components';
import { PaddingProps } from 'styled-system';

import { Box } from 'components/Box';
import { colors } from 'theme';

export const CmsStickyHeaderLinksContainer = styled(
  ({
    isSticky,
    ...props
  }: { isSticky: boolean; children: ReactNode } & PaddingProps) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box {...props} />
  ),
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
).attrs<any>(({ isSticky }) => ({
  style: {
    transform: isSticky
      ? 'translateY(0)'
      : 'translateY(-100%) translateY(-8px)',
  },
}))`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 103;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: ${colors.white};
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.075);
  transition: transform 0.45s ease;
`;
